<template>
    <div class="team">
        <router-view></router-view>
        <!-- <div class="test" @click="resetH5">点击重置弹窗</div> -->
        <!-- <div class="test">当前域名：{{domain}}</div>    -->
        <div class="h5-mask" v-show="showH5Mask">
            <div class="h5-content">
                <img src="../../assets/imgs/h5-star.png" alt class="h5-star" />
                <img src="../../assets/imgs/h5-text.png" alt class="h5-text" />
                <img @click="closeMask" src="../../assets/imgs/h5-close.png" alt class="h5-close" />
                <div @click="goH5Page" class="entry-btn">查看我的年度星认证</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "team",
    computed: {
        keepAlive() {
            return this.$route.meta.keepAlive
        }
    },
    mounted() {
        // 如果本地没有该字段，或者该字段为'true'，就显示遮罩
        // if (!localStorage.isFirstShowH5 || localStorage.isFirstShowH5 === "true") {
        //     this.showH5Mask = true
        // } else {
        //     this.showH5Mask = false
        // }
    },
    data() {
        return {
            showH5Mask: false
        }
    },
    methods: {
        resetH5() {
            localStorage.isFirstShowH5 = ""
            this.$root.eventBus.$emit("showTip", "已经重置H5提示，可以重新进入", "failed")
        },

        closeMask() {
            this.showH5Mask = false
            localStorage.isFirstShowH5 = "false"
        },

        goH5Page() {
            this.showH5Mask = false
            localStorage.isFirstShowH5 = "false"
            let url = `https://report.${domain}.com?from=${window.system}&user_id=${localStorage.userId}`
            window.open(url, "_system")
        }
    }
}
</script>

<style lang="scss" scoped>
.team {
    height: 100%;
    .test {
        padding: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: red;
        position: fixed;
        top: 100px;
        left: 0;
        z-index: 1000;
        font-size: 16px;
    }
    .h5-mask {
        position: fixed;
        z-index: 112;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        .h5-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 340px;
            width: 279px;
            background: url("../../assets/imgs/h5-bg.png") center center no-repeat;
            background-size: cover;
            display: flex;
            justify-content: center;
            .h5-star {
                position: absolute;
                top: -7px;
                left: -25px;
                width: 76px;
                height: 56px;
            }
            .h5-text {
                position: relative;
                z-index: 2;
                width: 229px;
                height: 73.5px;
                margin-top: 36px;
            }
            .h5-close {
                position: absolute;
                bottom: -74px;
                width: 34px;
                height: 34px;
            }
            .entry-btn {
                position: absolute;
                bottom: 15px;
                left: 50%;
                transform: translate(-50%);
                width: 252px;
                height: 44px;
                background: linear-gradient(180deg, rgba(255, 228, 137, 1) 0%, rgba(251, 137, 0, 1) 100%);
                box-shadow: 0px 5px 10px 0px rgba(19, 52, 128, 1);
                border-radius: 4px;
                text-align: center;
                font-size: 16px;
                font-family: PingFang-SC-Medium, PingFang-SC;
                font-weight: 700;
                color: rgba(169, 74, 0, 1);
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}
</style>